<ngx-extended-pdf-viewer
  [enablePrint]="printAllowed"
  [showPrintButton]="printAllowed"
  [showDownloadButton]="downloadAllowed"
  [showOpenFileButton]="false"
  [showDrawEditor]="false"
  [showTextEditor]="false"
  [showStampEditor]="false"
  [showHighlightEditor]="false"
  [showFindButton]="true"
  [textLayer]="true"
  [src]="blob"
  [(page)]="page"
  [showHandToolButton]="true"
  [language]='selectedLanguage'
  (pdfLoaded)="pdfDocumentLoaded()"
  (pageChange)="pageChanged($event)"
  (currentZoomFactor)='zoomChanged($event)'
></ngx-extended-pdf-viewer>
